import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Rohan Kumar </span>
            from <span className="purple"> Darbhanga,Bihar,India.</span>
            <br /> I am a 2023 passout B.Tech in INFORMATION TECHNOLOGY from CUSAT.
            
            <br />
            Additionally, I am enthusiastic about web technologies and software development.
            <br />
            <br />
            Some of my hobbies are 
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Finance
            </li>
            <li className="about-activity">
              <ImPointRight /> Art
            </li>
            
          </ul>
          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
